(function(){
    'use strict';

    var forms = {};

    forms.init = function() {
        $.validator.addMethod("nospaces", function(value, element) {
            return this.optional(element) || (value.indexOf(' ') === -1);
        });

        $.validator.addMethod("postcode", function(value, element) {
            return this.optional(element) || (!isNaN(value) && value.length === 4);
        });

        $('.qhealth__form--validate').each(function() {
            var $form = $(this);

            // Validate form
            $form.validate({

                // Error properties
                errorElement: 'p',
                errorClass: 'qhealth__input--error',
                errorAttribute: 'tabindex=”0″',

                // Place error appropriately in DOM
                errorPlacement: function(error, element) {
                    if (element.closest(".sq-form-question-answer").length > 0) {
                        var errorPlacement = element.closest(".sq-form-question-answer").parent();
                        var errorID = '#' + error[0].id.replace( /(:|\.|\[|\]|,|=|@)/g, "\\$1" );
                        error.attr('tabindex','0');
                        if(errorPlacement.find(errorID).length === 0){
                           error.prependTo(errorPlacement);
                        }
                        error.focus();
                        
                    } else if (element.closest(".qhealth__form-group").length > 0) {
                        error.attr('tabindex','0');
                        error.prependTo(element.closest(".qhealth__form-group"));
                        error.focus();
                    }
                },

                // Set valid class
                validClass: 'qhealth__input--valid',

                // Check validation on focus out
                onfocusout: function(element) {
                    $(element).valid();
                },

                // Check validation on click
                onclick: function(element) {
                    if ( element.type === "radio" || element.type === "checkbox") {
                        $(element).valid();
                    }
                },

                // Highlight invalid
                highlight: function( element, errorClass, validClass ) {
                    if ( element.type === "radio" || element.type === "checkbox") {
                        this.findByName( element.name ).addClass( errorClass ).removeClass( validClass );
                    } else {
                        $( element ).addClass( errorClass ).removeClass( validClass );
                    }
                },

                // Highlight valid
                unhighlight: function( element, errorClass, validClass ) {
                    if ( element.type === "radio" || element.type === "checkbox") {
                        if(this.findByName(element.name).is(":checked") || this.findByName(element.name).is(":selected")){
                            this.findByName( element.name ).removeClass( errorClass );
                        }  
                    } else {
                        if ($( element ).val().length > 0){
                            $( element ).removeClass( errorClass );
                        }
                    }
                }
            });

            // Add custom rules if they exist
            if (typeof(addCustomRules) !== 'undefined') {
                addCustomRules();
            }

            // Add required labels to fields
            updateRequiredLabels($form);
            $form.on('change', function() {
                updateRequiredLabels($(this));
            });
            // Add aria tag to helper text
            updateHelperText($form);

            //Add data auto complete to date field ---Matrix bug fix---
            dobFieldAutocomplete($form);

            // Validate select fields when option is selected
            $form.find('select').on('change', function() {
                console.log('select change');
                $(this).valid();
            });
        });
    }

    // Make forms available to public
    QH.forms = forms;
    
    $(document).ready(function() {
        QH.forms.init();
    });

    function updateRequiredLabels($form) {
        var $requiredFields = $form.find('[required]');
            
        $requiredFields.each(function() {
            var $field = $(this);
            var $question = $field.closest('.sq-form-question');
            
            if ($question.length > 0) {
                var $requiredLabel = $question.find('.sq-form-required-field');
                
                if ($requiredLabel.length === 0) {
                    var $title = $question.find('.sq-form-question-title');
                    $title.append(' <abbr class="sq-form-required-field" title="required">*</abbr>');
                }
            }
            
        });
    };
    function updateHelperText($form) {
        var $allFields = $form.find('input:not([type=hidden])');

        $allFields.each(function() {
            var currentField = $(this);
            var currentID = $(this).attr('id');

            if(currentField.parents('.sq-form-question-answer').siblings('.sq-form-question-note').length){
                currentField.attr('aria-describedby', currentID + '_description');
                currentField.parents('.sq-form-question-answer').siblings('.sq-form-question-note').attr('id', currentID + '_description');

            }
        });
    };

    function dobFieldAutocomplete($form) {
        var $dateFieldWrapper = $form.find('.sq-form-question-datetime');

        if($dateFieldWrapper.length){
            var $dateFieldWrapperId = $form.find('.sq-form-question-datetime').attr('id');
            var $dateFieldLegend = $dateFieldWrapper.find('legend');
            var $dateFieldLegendId = $dateFieldWrapperId.replace( /(wrapper)/g, "legend" );
            var $dateField = $dateFieldWrapper.find('input:not([type=hidden])');
            
            var $dateHelperTextId = $dateFieldWrapper.find('em.sq-form-question-note').attr('id');

            $dateFieldLegend.attr('id', $dateFieldLegendId);
            $dateFieldLegend.attr('aria-labeledby', $dateFieldLegendId + " " + $dateHelperTextId);

            if($dateFieldWrapper.find('.sq-form-question-title').text().toLowerCase().indexOf("birth") >= 0){
                $dateField.each(function() {
                    var currentField = $(this);
                    var currentID = $(this).attr('id');
                    if(currentID.toLowerCase().indexOf("value_d") >= 0){
                        currentField.attr('autocomplete', 'bday-day');
                    }else if(currentID.toLowerCase().indexOf("value_m") >= 0){
                        currentField.attr('autocomplete', 'bday-month');
                    }else if(currentID.toLowerCase().indexOf("value_y") >= 0){
                        currentField.attr('autocomplete', 'bday-year');
                    }

                });
            }
        }
        




    };
    
}());
